import React, { useState } from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import Header from '../directives/header';
import Footer from '../directives/footer';
import Sidebar from '../directives/sidebar';
import { changePasswordAction } from '../Action/action';
import toast, { Toaster } from 'react-hot-toast';
import { Col, Row } from 'react-bootstrap';
// Validation Schema
const validationSchema = Yup.object().shape({
  oldPassword: Yup.string()
    .required('Old password is required')
    .min(8, 'Password must be at least 8 characters')
    .matches(
      /^(?=.*[a-zA-Z])(?=.*[0-9])(?=.*[!@#$%^&*])/,
      'Password must contain at least one letter, one number, and one special character'
    ),
  newPassword: Yup.string()
    .required('New password is required')
    .min(8, 'Password must be at least 8 characters')
    .notOneOf([Yup.ref('oldPassword')], 'New password must be different from old password')
    .matches(
      /^(?=.*[a-zA-Z])(?=.*[0-9])(?=.*[!@#$%^&*])/,
      'Password must contain at least one letter, one number, and one special character'
    ),
  confirmPassword: Yup.string()
    .required('Confirm password is required')
    .oneOf([Yup.ref('newPassword')], 'Passwords must match')
});

const Changepassword = () => {
  const [showPassword, setShowPassword] = useState({
    oldPassword: false,
    newPassword: false,
    confirmPassword: false
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const initialValues = {
    oldPassword: '',
    newPassword: '',
    confirmPassword: ''
  };

  const togglePasswordVisibility = (fieldName) => {
    setShowPassword(prev => ({
      ...prev,
      [fieldName]: !prev[fieldName]
    }));
  };

  const handleSubmit = async (values, { resetForm }) => {
    try {
      setIsSubmitting(true);
      toast.dismiss()
      const res = await changePasswordAction({
        oldPassword: values.oldPassword,
        newPassword: values.newPassword,
        confirmPassword: values.confirmPassword,
      });
      if (res.status) {
        toast.success(res.msg);
        resetForm();
      } else {
        toast.error(res.msg);
      }
    } catch (error) {
      toast.error('An error occurred while changing password');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="wrapper h-auto">
      <Header />
      <Toaster />
      <Sidebar />
      <div className="content-wrapper">
        <div className="container-full">
          <section className="content">
            <div className="row">
              <div className="col-lg-12 col-12">
                <div className="box">
                  <div className="box-header with-border">
                    <h3 className="box-title" style={{ fontWeight: 600 }}>Change Password</h3>
                  </div>
                  <Formik
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    onSubmit={handleSubmit}
                  >
                    {() => (
                      <Form className="p-4 change-password-form">
                        <Row>
                          <Col md={8} lg={6} xl={5}>
                            <div className="form-group mb-3">
                              <label className="form-label">Old Password</label>
                              <div className="input-group passfield">
                                <Field
                                  name="oldPassword"
                                  type={showPassword.oldPassword ? 'text' : 'password'}
                                  className="form-control"
                                  placeholder="Enter old password"
                                  autoComplete="current-password"
                                />
                                <button
                                  type="button"
                                  className="input-group-text password-toggle"
                                  onClick={() => togglePasswordVisibility('oldPassword')}
                                  aria-label={showPassword.oldPassword ? 'Hide old password' : 'Show old password'}
                                >
                                  <i className={`fa ${showPassword.oldPassword ? 'fa-eye' : 'fa-eye-slash'}`} />
                                </button>
                              </div>
                              <ErrorMessage name="oldPassword" component="div" className="text-danger small mt-1" />
                            </div>

                            <div className="form-group mb-3">
                              <label className="form-label">New Password</label>
                              <div className="input-group passfield">
                                <Field
                                  name="newPassword"
                                  type={showPassword.newPassword ? 'text' : 'password'}
                                  className="form-control"
                                  placeholder="Enter new password"
                                  autoComplete="new-password"
                                />
                                <button
                                  type="button"
                                  className="input-group-text password-toggle"
                                  onClick={() => togglePasswordVisibility('newPassword')}
                                  aria-label={showPassword.newPassword ? 'Hide new password' : 'Show new password'}
                                >
                                  <i className={`fa ${showPassword.newPassword ? 'fa-eye' : 'fa-eye-slash'}`} />
                                </button>
                              </div>
                              <ErrorMessage name="newPassword" component="div" className="text-danger small mt-1" />
                            </div>

                            <div className="form-group mb-4">
                              <label className="form-label">Confirm Password</label>
                              <div className="input-group passfield">
                                <Field
                                  name="confirmPassword"
                                  type={showPassword.confirmPassword ? 'text' : 'password'}
                                  className="form-control"
                                  placeholder="Confirm new password"
                                  autoComplete="new-password"
                                />
                                <button
                                  type="button"
                                  className="input-group-text password-toggle"
                                  onClick={() => togglePasswordVisibility('confirmPassword')}
                                  aria-label={showPassword.confirmPassword ? 'Hide confirm password' : 'Show confirm password'}
                                >
                                  <i className={`fa ${showPassword.confirmPassword ? 'fa-eye' : 'fa-eye-slash'}`} />
                                </button>
                              </div>
                              <ErrorMessage name="confirmPassword" component="div" className="text-danger small mt-1" />
                            </div>

                            <div className="text-end">
                              <button
                                type="submit"
                                className="btn btn-primary"
                                disabled={isSubmitting}
                              >
                                {isSubmitting ? 'Updating...' : 'Update'}
                              </button>
                            </div>
                          </Col>
                        </Row>
                      </Form>
                    )}
                  </Formik>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Changepassword;